import * as React from 'react';

import {Checkbox} from 'shells/checkbox/checkbox';
import {FormField} from 'shells/form/form-field';

type Props = {
    isStopOnGoalMet: boolean;
    setIsStopOnGoalMet: (arg1: boolean) => void;
};

export function StopOnGoalMet(props: Props) {
    return (
        <FormField innerId='stop-on-goal-met'>
            <div style={{marginTop: '16px'}}>
                <Checkbox
                    checked={props.isStopOnGoalMet}
                    isLarge={true}
                    label='Stop sending messages when the goal is met'
                    onChange={(newValue) => {
                        props.setIsStopOnGoalMet(newValue);
                    }}
                />
            </div>
        </FormField>
    );
}
